import { useCachedMembers, useIsAdminOrManagerRole } from '@easy-expense/data-firestore-client';
import { getTranslation } from '@easy-expense/intl-client';
import { Icon } from '@easy-expense/ui-shared-components';
import { theme } from '@easy-expense/ui-theme';
import { Layout, OpenSans, Spacer } from '@easy-expense/ui-web-core';
import { getReportDisplayStatus } from '@easy-expense/utils-client';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useReportsRows } from './useReportTableRows';

export const ReportsApprovalBanner: React.FC = () => {
  const isManagerOrAdmin = useIsAdminOrManagerRole();
  const navigate = useNavigate();
  const reportRows = useReportsRows();
  const members = useCachedMembers();

  const reviewReports = React.useMemo(
    () =>
      reportRows.filter((report) => {
        const status = getReportDisplayStatus(report);
        return status === 'pending' || status === 'needsReimbursement';
      }),
    [reportRows],
  );

  /** Solo workspaces have no one to approve reports, so the banner is noise. */
  const hasTeammates = members.length > 1;

  if (!isManagerOrAdmin || !hasTeammates || reviewReports.length === 0) {
    return null;
  }

  return (
    <Layout.PressableRow
      align
      px={16}
      py
      radius={8}
      bg="warningXLight"
      border={[1, 'solid', 'warning']}
      onClick={() => navigate('/report-approvals')}
      style={{ paddingBottom: 8 }}
    >
      <Layout.Row bg="warningDark" radius={8} px={10} py={10} align center>
        <Icon name="alert-circle-outline" size={20} color={theme.colors.buttonWhite} />
      </Layout.Row>
      <Spacer.Horizontal size={16} />
      <Layout.Column grow>
        <OpenSans.Primary weight="bold-700" size="s-16" style={{ color: theme.colors.warningDark }}>
          {reviewReports.length === 1 ? getTranslation('There is') : getTranslation('There are')}{' '}
          {reviewReports.length}{' '}
          {reviewReports.length === 1
            ? getTranslation('report that needs review')
            : getTranslation('reports that need review')}
        </OpenSans.Primary>
      </Layout.Column>
      <Layout.Row px={20} py={10} bg="warningDark" radius={8} align>
        <OpenSans.Primary weight="bold-700" size="s-16" style={{ color: theme.colors.buttonWhite }}>
          {getTranslation('Review')}
        </OpenSans.Primary>
      </Layout.Row>
    </Layout.PressableRow>
  );
};
